import { render, staticRenderFns } from "./WorkplaceOrServiceDialog.vue?vue&type=template&id=51274866&scoped=true&"
import script from "./WorkplaceOrServiceDialog.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WorkplaceOrServiceDialog.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./WorkplaceOrServiceDialog.vue?vue&type=style&index=0&id=51274866&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51274866",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51274866')) {
      api.createRecord('51274866', component.options)
    } else {
      api.reload('51274866', component.options)
    }
    module.hot.accept("./WorkplaceOrServiceDialog.vue?vue&type=template&id=51274866&scoped=true&", function () {
      api.rerender('51274866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/DoctorPageLpuList/components/DoctorAppointmentCard/components/WorkplaceOrServiceDialog/WorkplaceOrServiceDialog.vue"
export default component.exports